module.exports = __webpack_public_path__ + "static/media/plaquette_commerciale_obseques.145bafaa.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/data/products/go/documents/common/plaquette_commerciale_obseques.pdf
// module id = 306
// module chunks = 40